import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const KvkkPage = () => {
  useEffect(() => {
    document.title = 'KVKK - Kişisel Verilerin Korunması - İzmir Tente Tamir';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir Tente Tamir kişisel verilerin korunması ve işlenmesi politikası. KVKK kapsamında haklarınız ve bilgilendirme metni.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Kişisel Verilerin Korunması ve İşlenmesi Politikası
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6 leading-relaxed">
              İzmir Tente Tamir olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında kişisel verilerinizin güvenliğine önem veriyoruz. Bu metin, kişisel verilerinizin nasıl toplandığı, işlendiği ve korunduğu hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">1. Veri Sorumlusu</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              KVKK kapsamında veri sorumlusu İzmir Tente Tamir'dir. İletişim bilgilerimiz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Adres: Karabağlar / İzmir</li>
              <li>Telefon: 0551 372 35 12</li>
              <li>Web: izmirtentetamir.net</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">2. Toplanan Kişisel Veriler</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Hizmetlerimizi sunabilmek için aşağıdaki kişisel verilerinizi toplayabiliriz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li><strong>Kimlik Bilgileri:</strong> Ad, soyad</li>
              <li><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi, adres</li>
              <li><strong>Müşteri İşlem Bilgileri:</strong> Hizmet talepleri, randevu bilgileri, fiyat teklifleri</li>
              <li><strong>İşlem Güvenliği Bilgileri:</strong> IP adresi, çerez bilgileri</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">3. Kişisel Verilerin İşlenme Amaçları</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Hizmet taleplerinin alınması ve yerine getirilmesi</li>
              <li>Müşteri ilişkileri yönetimi</li>
              <li>Randevu oluşturma ve takibi</li>
              <li>Fiyat teklifi hazırlama</li>
              <li>İletişim ve bilgilendirme</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>Web sitesi güvenliğinin sağlanması</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">4. Kişisel Verilerin Aktarılması</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve KVKK'nın öngördüğü şartlara uygun olarak, iş ortaklarımıza, tedarikçilerimize ve yasal yükümlülüklerimiz gereği resmi kurumlara aktarılabilir.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">5. Kişisel Verilerin Toplanma Yöntemi</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Kişisel verileriniz aşağıdaki yöntemlerle toplanmaktadır:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Web sitesi üzerinden yapılan başvurular</li>
              <li>Telefon görüşmeleri</li>
              <li>WhatsApp iletişimi</li>
              <li>E-posta yazışmaları</li>
              <li>Yüz yüze görüşmeler</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">6. KVKK Kapsamındaki Haklarınız</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
              <li>Kişisel verilerinizin düzeltilmesi, silinmesi veya yok edilmesi halinde bu işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">7. Başvuru Yöntemi</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Yukarıda belirtilen haklarınızı kullanmak için bize aşağıdaki yöntemlerle başvurabilirsiniz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Telefon: 0551 372 35 12</li>
              <li>Adres: Karabağlar / İzmir</li>
            </ul>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Başvurularınız en geç 30 gün içinde değerlendirilecek ve sonuçlandırılacaktır.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">8. Kişisel Verilerin Güvenliği</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Kişisel verilerinizin güvenliğini sağlamak için gerekli teknik ve idari tedbirleri alıyoruz. Verileriniz yetkisiz erişime, kayba veya değişikliğe karşı korunmaktadır.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">9. Politika Güncellemeleri</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Bu politika, yasal düzenlemelerdeki değişiklikler veya iş süreçlerindeki güncellemeler doğrultusunda revize edilebilir. Güncel versiyona web sitemizden ulaşabilirsiniz.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">10. İletişim</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              KVKK kapsamındaki haklarınız veya kişisel verilerinizin işlenmesi hakkında sorularınız için bizimle iletişime geçebilirsiniz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Telefon: 0551 372 35 12</li>
              <li>Adres: Karabağlar / İzmir</li>
            </ul>

            <p className="text-gray-700 mt-8 text-sm">
              <strong>Son Güncelleme:</strong> 01.01.2025
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Anasayfaya Dön
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KvkkPage;
